import MarketingBanner from "components/marketing_banner";

$(() => {
  new Vue({
    el: document.querySelector(".v-manage-marketing-banners-controller"),
    components: { MarketingBanner },
  });
});
